import DOMPurify from 'isomorphic-dompurify';

const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    'a',
    'b',
    'blockquote',
    'br',
    'code',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'li',
    'ol',
    'p',
    'pre',
    's',
    'small',
    'span',
    'strong',
    'sub',
    'sup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'u',
    'ul',
  ],
  ALLOWED_ATTR: ['alt', 'colspan', 'href', 'rel', 'rowspan', 'src', 'target', 'title'],
  ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|\/|#)/i,
};

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  const el = node as Element;
  if (el.tagName === 'A' && el.getAttribute('target') === '_blank') {
    el.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * Sanitizes admin-authored HTML rendered via dangerouslySetInnerHTML.
 * Strips scripts, event handlers, javascript:/data: URLs, and any tag
 * outside the allowlist.
 */
export function sanitizeRichTextHtml(html: unknown): string {
  if (typeof html !== 'string' || html.length === 0) {
    return '';
  }
  return DOMPurify.sanitize(html, RICH_TEXT_CONFIG) as unknown as string;
}

const SAFE_LINK_REGEXP = /^(?:https?:\/\/|mailto:|\/|#)/i;

/**
 * Returns the URL only if it uses a safe scheme. Used for admin-supplied
 * link targets so they can't smuggle in `javascript:` or `data:` URLs.
 */
export function sanitizeLinkUrl(url: unknown): string | undefined {
  if (typeof url !== 'string' || url.length === 0) {
    return undefined;
  }
  const trimmed = url.trim();
  return SAFE_LINK_REGEXP.test(trimmed) ? trimmed : undefined;
}
